const newsletter = {
    getlist: 'newsletter/getlist',
    update: 'newsletter/update',
    remove: 'newsletter/remove',
}
export default newsletter
